import axios from 'axios'
import {MessageBox} from 'element-ui'
import {Message} from '@/components'

import * as ErrorInfo from '../store/ErrorInfo'
import {utils} from "../components";

let redirect = false;

// 拦截request,设置全局请求为ajax请求
axios.interceptors.request.use((config) => {
  config.headers['X-Requested-With'] = 'XMLHttpRequest'

  return config
});

// 拦截响应response，并做一些错误处理
axios.interceptors.response.use((response) => {
  const data = response.data;
  // 根据返回的code值来做不同的处理（和后端约定）
  if (data.status !== undefined) {
    if (data.status === '0' || data.status === 0)
      // 这一步保证数据返回，如果没有return则会走接下来的代码，不是未登录就是报错
      return data;
    else {
      // 若不是正确的返回code，且已经登录，就抛出错误
      const err = new Error(data.msg);
      err.data = data;
      err.response = response;
      Message.error(data.msg);
      throw err
    }
  } else if (data.stateCode != undefined) {
    if (data.stateCode === 'jb_000000') {
      return data
    } else if (data.stateCode === "oauth2_000000") {
      return data
    } else {

      let msg = ErrorInfo[data.stateCode];
      msg = utils.isNotEmpty(msg) ? msg : data.description;

      // 若不是正确的返回code，且已经登录，就抛出错误
      const err = new Error(msg)
      err.data = data
      err.response = response
      Message.error(msg)
      throw err
    }
  }

  // 如果调用的是认证接口,则返回的格式不同于传统业务的格式
  if (data['access_token'] !== undefined || utils.isNotEmpty(data["tmp_access_token"]) ) {
    return data
  }

  if (data["error"] !== undefined) {
    Message.error(data["error_description"]);
    const err = new Error(data["error_description"]);
    throw err
  }

  if (data['success'] !== undefined) {
    return data;
  }


}, (err) => { // 这里是返回状态码不为200时候的错误处理
  if (err && err.response) {
    let data = err.response.data
    let msg = ErrorInfo[data.stateCode];
    let showError = true;

    switch (err.response.status) {
      case 400:
        err.message = '请求错误'
        break

      case 401:

        showError = false;
        if (err.response.data.description) {
          err.message = err.response.data.description
        } else {
          err.message = '401'
        }

        if (err.response.data.stateCode === 'oauth2_100103') {
          err.message = msg;
          showError = true
        } else {
          if (redirect) return;

          redirect = true;
          err.message = utils.isNotEmpty(msg) ? msg : data.description;
          MessageBox.alert(err.message, '提示', {
            confirmButtonText: '确定',
            callback: () => {
              // location.href = `${AIM_URL}/logout`
              location.href = './login.html'
            }
          })
        }
        break
      case 403:
        err.message = '拒绝访问'
        break

      case 404:
        err.message = `请求地址出错: ${err.response.config.url}`
        break

      case 408:
        err.message = '请求超时'
        break

      case 500:
        err.message = '服务器内部错误'
        break

      case 501:
        err.message = '服务未实现'
        break

      case 502:
        err.message = '网关错误'
        break

      case 503:
        err.message = '服务不可用'
        break

      case 504:
        err.message = '网关超时'
        break

      case 505:
        err.message = 'HTTP版本不受支持'
        break

      default:
    }
    if (showError)
      Message.error(err.message);
  }

  return Promise.reject(err)
});


export default axios
